import React from 'react';
import { Grid } from '@material-ui/core';
import { getToken } from '@ctsu/loader';
import { RenderControl, RenderElement } from 'components/RenderHelpers';
import { CanUserViewSync, CanUserAccessInfo } from 'appconstants/Permission';
import { ProtocolBrowserInfo } from './components';

const ProtocolBrowser = () => (
  <>
    <div data-id="skip" id="skip">
      <a href="#footer">Skip to Footer</a>
    </div>
    <RenderControl
      isLoading={false}
      iserror={false}
      compName="Browser Information"
      permission={CanUserAccessInfo()}
    >
      <div className="card-wrapper MuiPaper-elevation1">
        <Grid container spacing={4}>
          <Grid item lg={12} xs={12}>
            <RenderElement access>
              <ProtocolBrowserInfo
                getToken={getToken}
                syncPermission={CanUserViewSync()}
              />
            </RenderElement>
          </Grid>
        </Grid>
      </div>
    </RenderControl>
  </>
);
export { ProtocolBrowser };
